import { render } from "./MPageTemplate.vue?vue&type=template&id=a95e61a0"
import script from "./MPageTemplate.vue?vue&type=script&lang=ts"
export * from "./MPageTemplate.vue?vue&type=script&lang=ts"

import "./MPageTemplate.vue?vue&type=style&index=0&id=a95e61a0&lang=css"
script.render = render

export default script